(() => {
  const stage = document.querySelector('.step-content');
  if (!stage) return;
  let railCleanup = () => {};
  function initRail() {
    railCleanup();
    const rail = stage.querySelector('.video-row');
    if (!rail) return;
    const group = rail.querySelector('.video-track__group');
    if (!group) return;
    rail.tabIndex = 0;
    rail.setAttribute('aria-label', 'Reviewvideos – nach links und rechts scrollen');
    let frame, previous = 0, pauseUntil = 0, position = rail.scrollLeft;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const pause = () => { pauseUntil = performance.now() + 6000; };
    const events = ['pointerdown', 'pointermove', 'touchstart', 'wheel', 'keydown', 'focusin'];
    events.forEach(name => rail.addEventListener(name, pause, {passive:true}));
    let drag = null;
    const dragStart = event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
      drag = {x:event.clientX, scroll:rail.scrollLeft};
      rail.setPointerCapture(event.pointerId);
      rail.classList.add('is-dragging');
      event.preventDefault();
    };
    const dragMove = event => {
      if (!drag) return;
      rail.scrollLeft = drag.scroll + drag.x - event.clientX;
      pause();
    };
    const dragEnd = () => { drag = null; rail.classList.remove('is-dragging'); pause(); };
    rail.addEventListener('pointerdown', dragStart);
    rail.addEventListener('pointermove', dragMove);
    rail.addEventListener('pointerup', dragEnd);
    rail.addEventListener('pointercancel', dragEnd);
    rail.addEventListener('lostpointercapture', dragEnd);
    function tick(now) {
      const elapsed = Math.min(now - (previous || now), 64);
      previous = now;
      if (!drag && !reduced.matches && !document.hidden && now > pauseUntil && group.offsetWidth > 0) {
        position += elapsed * 0.028;
        if (position >= group.offsetWidth) position %= group.offsetWidth;
        rail.scrollLeft = position;
      } else position = rail.scrollLeft;
      frame = requestAnimationFrame(tick);
    }
    frame = requestAnimationFrame(tick);
    railCleanup = () => {
      cancelAnimationFrame(frame);
      events.forEach(name => rail.removeEventListener(name, pause));
      rail.removeEventListener('pointerdown', dragStart);
      rail.removeEventListener('pointermove', dragMove);
      ['pointerup','pointercancel','lostpointercapture'].forEach(name => rail.removeEventListener(name, dragEnd));
    };
  }
  const speaker = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4Z"/><path class="review-sound-waves" d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/><path class="review-sound-cross" d="m16 9 6 6m0-6-6 6"/></svg>';
  function updateButtons() {
    stage.querySelectorAll('.review-sound').forEach(button => {
      const video = button.closest('.review-video').querySelector('video');
      const silent = button.disabled;
      const audible = !silent && !video.muted;
      button.innerHTML = speaker + '<span>' + (silent ? 'Stumm' : audible ? 'Ton aus' : 'Ton an') + '</span>';
      button.setAttribute('aria-pressed', String(audible));
      button.setAttribute('aria-label', silent ? 'Dieses Video ist ohne Ton' : audible ? 'Video stummschalten' : 'Videoton einschalten');
      button.classList.toggle('is-audible', audible);
    });
  }
  function init() {
    stage.querySelectorAll('.review-video video').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.play().catch(() => {});
    });
    updateButtons();
    initRail();
  }
  stage.addEventListener('click', event => {
    const button = event.target.closest('.review-sound');
    if (!button || button.disabled) return;
    const video = button.closest('.review-video').querySelector('video');
    const enable = video.muted;
    stage.querySelectorAll('.review-video video').forEach(item => { item.muted = true; });
    video.muted = !enable;
    video.play().catch(() => { video.muted = true; updateButtons(); });
    updateButtons();
  });
  new MutationObserver(records => {
    if (records.some(record => record.target === stage)) init();
  }).observe(stage, { childList: true });
  init();
})();
